import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
  name: Yup.string().trim().min(2).required(),
  isBenchmark: Yup.boolean().required(),
  type: Yup.string().trim().required(),
  baseDate: Yup.date().nullable().required(),
  tenantId: Yup.number().nullable(),
  '1M': Yup.number().nullable(),
  '2M': Yup.number().nullable(),
  '3M': Yup.number().nullable(),
  '4M': Yup.number().nullable(),
  '5M': Yup.number().nullable(),
  '6M': Yup.number().nullable(),
  '7M': Yup.number().nullable(),
  '8M': Yup.number().nullable(),
  '9M': Yup.number().nullable(),
  '10M': Yup.number().nullable(),
  '11M': Yup.number().nullable(),
  '12M': Yup.number().nullable(),
  '2Y': Yup.number().nullable(),
  '3Y': Yup.number().nullable(),
  '4Y': Yup.number().nullable(),
  '5Y': Yup.number().nullable(),
  YTD: Yup.number().nullable(),
})
